// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3iLAD","description":"PatientConsentPreview_description__1bKEk"};